import { Box, styled } from "@mui/material";
import React, { useState } from "react";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useNavigate } from "react-router-dom";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  border: `none`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }: any) => ({
  padding: theme.spacing(2),
}));

const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none",
        },
        ".expandIconWrapper": {
          display: "none",
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block",
        },
      }}
    >
      <div className="expandIconWrapper">-</div>
      <div className="collapsIconWrapper">+</div>
    </Box>
  );
};

const TopBox = styled(Box)({
  padding: "0 20px",

  "&:nth-last-child(1)": {
    paddingRight: "0",
  },

  "& .footer-links": {
    display: "none",
  },

  "& h4": {
    color: "#FFF",
    fontSize: 15,
    lineHeight: "19px",
    fontFamily: "Inter",
    fontWeight: 600,
    margin: 0,
    padding: "0 0 10px",
  },
  "& ul": {
    listStyleType: "none",
    margin: 0,
    padding: 0,

    "& li": {
      color: "#FFF",
      fontSize: 15,
      lineHeight: "19px",
      fontFamily: "Inter",
      fontWeight: 500,
      cursor: "pointer",
      margin: 0,
      padding: "10px 0",
    },
  },
  "@media only screen and (min-width: 320px) and (max-width: 768px)": {
    width: "100%",

    "& h4": {
      display: "none",
    },
    "& ul": {
      display: "none",
      "& li": {
        fontSize: 13,
      },
    },
    "& .footer-links": {
      display: "block",
      width: "100%",
      "& .MuiButtonBase-root": {
        padding: 0,
      },
      "& .MuiAccordionDetails-root": {
        padding: 0,
      },
      "& .MuiPaper-root.MuiAccordion-root": {
        backgroundColor: "transparent",
      },
      "& .MuiAccordionSummary-expandIconWrapper": {
        color: "#FFF",
      },
      "& h4": {
        display: "block",
        margin: 0,
        padding: "0",
      },
      "& ul": {
        display: "block",
        "& li": {
          fontSize: 13,
        },
      },
    },
  },
});

interface FooterLinkInterface {
  title: String;
  links: [];
}

/**
 *
 * @param title title of the section
 * @param links links of the section
 * @returns
 */
const FooterLinkSections = ({ title, links }: FooterLinkInterface) => {
  const [expanded, setExpanded] = useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const navigate = useNavigate();

  const navigateToRoute = (link: string, label: any) => {
    if (label === "Help Center")
      window.location.href = "mailto:help@haystackers.com";

    if (!link) return;
    if (link === "openChat") {
      (window as any).tidioChatApi.open();
      return;
    }

    label == "Press" ? window.location.assign(link) : navigate(link);
  };
  return (
    <>
      <TopBox>
        <h4>{title}</h4>
        <ul>
          {links.map(({ label, link }) => (
            <li key={label} onClick={() => navigateToRoute(link, label)}>
              {label}
            </li>
            // <Links
            //   key={label}
            //   role="button"
            //   color="common.white"
            //   onClick={() => navigateToRoute(link)}
            // >
            //   {label}
            // </Links>
          ))}
        </ul>

        <div className="footer-links">
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<CustomExpandIcon />}
            >
              <h4>{title}</h4>
            </AccordionSummary>
            <AccordionDetails>
              <ul>
                {links.map(({ label, link }) => (
                  <li key={label} onClick={() => navigateToRoute(link, label)}>
                    {label}
                  </li>
                ))}
              </ul>
            </AccordionDetails>
          </Accordion>
        </div>
      </TopBox>
    </>
  );
};

export default FooterLinkSections;
